import Cookies from "js-cookie";
import queryString from "query-string";

/**
 * Decorate the original url with a /csrf/fix view/url that will set the missing csrf
 * token. This is a useful workaround for Safari's security policy that block cookies
 * in iframes if the user has never visited the site outside of an iframe.
 *
 * Note: The backend requires the `next` url to be strictly the POPUP_SPLASH_URL based
 * on security concerns.
 *
 * @param {string} url The absolute URL to potentially decorate
 *
 * @returns {string} The decorated URL, if required. Otherwise the original URL
 */
export const maybeCsrfFix = (url: string) => {
  if (Cookies.get("csrftoken")) {
    return url;
  }

  const { origin } = new URL(url);
  const csrfUrl = new URL("/csrf/fix/", origin);
  const next = url.slice(origin.length);

  return queryString.stringifyUrl({
    url: csrfUrl.toString(),
    query: {
      next,
    },
  });
};
